import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MomentModule } from 'ngx-moment';

import { ModalModule } from 'ngx-bootstrap/modal';

import { DownloadComponent, DownloadRouting  } from './index';

import { SharedModule } from './../shared/shared.module';


@NgModule({
    imports: [
        CommonModule,
        MomentModule,
        FormsModule,

        SharedModule,

        DownloadRouting,

        ModalModule.forRoot()
    ],
    declarations: [
        DownloadComponent,
        //LoginComponent
    ]
})
export class DownloadModule { }
